import { render, staticRenderFns } from "./InterfaceTest.vue?vue&type=template&id=77016640&"
import script from "./InterfaceTest.vue?vue&type=script&lang=js&"
export * from "./InterfaceTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77016640')) {
      api.createRecord('77016640', component.options)
    } else {
      api.reload('77016640', component.options)
    }
    module.hot.accept("./InterfaceTest.vue?vue&type=template&id=77016640&", function () {
      api.rerender('77016640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/InterfaceTest.vue"
export default component.exports